import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { homeStories } from "../../../data/alumniStories";
import StoryCard from "../../../components/Testimonials/StoryCard";
import StoryLightbox from "../../../components/Testimonials/StoryLightbox";

const ArdrendTestimonials = () => {
  const { t } = useTranslation();
  const [openStory, setOpenStory] = useState(null);

  return (
    <section className="py-24 lg:py-32 bg-gray-50 overflow-hidden relative">
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            animation: marquee 60s linear infinite;
          }
          .animate-marquee:hover {
            animation-play-state: paused;
          }
          @media (prefers-reduced-motion: reduce) {
            .animate-marquee { animation: none; }
            .marquee-viewport { overflow-x: auto; }
            .marquee-dup { display: none; }
          }
        `}
      </style>

      <div className="max-w-[1560px] mx-auto px-6 mb-16 lg:mb-20 relative z-10">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8">
          <div className="w-full lg:w-1/2">
            <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-gray-400 mb-6 flex items-center gap-3">
              <span className="block w-8 h-[2px] bg-primary"></span>
              {t("home.testimonials.kicker")}
            </div>
            <h2 className="text-[#0b0f19] text-3xl md:text-5xl font-bold">
              {t("home.testimonials.title")}<span className="text-primary">.</span>
            </h2>
          </div>
          <div className="w-full lg:w-1/2 flex flex-col items-start lg:items-end gap-6">
            <p className="text-gray-500 text-lg max-w-[400px] leading-relaxed border-l border-primary/30 pl-6">
              {t("home.testimonials.subtitle")}
            </p>
            <Link
              to="/alumni-stories"
              className="bg-primary hover:bg-[#b0451e] text-white transition-colors rounded-full pl-5 pr-2 py-2 inline-flex items-center gap-3 group shadow-md"
            >
              <span className="text-[11px] font-bold uppercase tracking-wider">{t("stories.readAll")}</span>
              <div className="w-7 h-7 rounded-full bg-white flex items-center justify-center text-primary shrink-0">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                </svg>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Infinite marquee — the list is rendered twice for a seamless loop */}
      <div className="marquee-viewport relative w-full overflow-hidden flex pb-12">
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none"></div>

        <div className="flex animate-marquee w-max gap-6 px-4">
          {homeStories.map((story) => (
            <StoryCard key={story.id} story={story} onOpen={setOpenStory} variant="marquee" />
          ))}
          <div className="marquee-dup flex gap-6" aria-hidden="true">
            {homeStories.map((story) => (
              <div key={story.id} inert="" className="contents">
                <StoryCard story={story} onOpen={setOpenStory} variant="marquee" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {openStory && <StoryLightbox story={openStory} onClose={() => setOpenStory(null)} />}
    </section>
  );
};

export default ArdrendTestimonials;
